import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";

export const CONSENT_LS_KEY = "anatradex-cookie-consent";

export function getConsent() {
  try {
    const raw = localStorage.getItem(CONSENT_LS_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch { return null; }
}

function saveConsent(level) {
  const payload = { level, at: new Date().toISOString() };
  try { localStorage.setItem(CONSENT_LS_KEY, JSON.stringify(payload)); } catch { /* noop */ }
  window.dispatchEvent(new CustomEvent("anatradex-consent", { detail: payload }));
}

export default function CookieConsent() {
  const [consented, setConsented] = useState(() => !!getConsent());
  const [riskAcked, setRiskAcked] = useState(() => {
    try { return !!localStorage.getItem("qtr-risk-ack"); } catch { return true; }
  });
  const [wizardOpen, setWizardOpen] = useState(false);

  useEffect(() => {
    const onAck = () => setRiskAcked(true);
    const onWizOpen = () => setWizardOpen(true);
    const onWizClose = () => setWizardOpen(false);
    window.addEventListener("anatradex-risk-acked", onAck);
    window.addEventListener("anatradex-onboarding-open", onWizOpen);
    window.addEventListener("anatradex-onboarding-closed", onWizClose);
    return () => {
      window.removeEventListener("anatradex-risk-acked", onAck);
      window.removeEventListener("anatradex-onboarding-open", onWizOpen);
      window.removeEventListener("anatradex-onboarding-closed", onWizClose);
    };
  }, []);

  // One modal at a time: wait for the risk modal, never overlap the onboarding wizard
  if (consented || !riskAcked || wizardOpen) return null;

  const decide = (level) => {
    saveConsent(level);
    setConsented(true);
  };

  return (
    <div
      className="fixed bottom-0 inset-x-0 z-[1100] p-4 sm:p-5"
      data-testid="cookie-consent-banner"
    >
      <div className="max-w-3xl mx-auto rounded-2xl border border-white/10 bg-[#0b1420]/95 backdrop-blur-xl shadow-2xl p-5">
        <div className="flex items-start gap-3">
          <Cookie size={18} className="text-accent-blue shrink-0 mt-0.5" />
          <div className="flex-1">
            <div className="font-heading font-semibold text-sm mb-1">Cookies & mesure d&apos;audience</div>
            <p className="text-xs text-white/60 leading-relaxed">
              ANATRADEX utilise des cookies strictement nécessaires au fonctionnement (session, préférences)
              et, avec votre accord, des cookies de mesure d&apos;audience anonymisée. Aucune donnée n&apos;est
              vendue à des tiers. Détails : {" "}
              <Link to="/cookies" className="text-accent-blue underline">politique cookies</Link> · {" "}
              <Link to="/privacy" className="text-accent-blue underline">confidentialité</Link>.
            </p>
          </div>
        </div>
        <div className="flex flex-wrap gap-2 mt-4 justify-end">
          <button
            className="btn text-xs px-4 py-2"
            onClick={() => decide("essential")}
            data-testid="cookie-refuse-btn"
          >
            Continuer sans accepter
          </button>
          <button
            className="btn btn-primary text-xs px-4 py-2"
            onClick={() => decide("all")}
            data-testid="cookie-accept-btn"
          >
            Tout accepter
          </button>
        </div>
      </div>
    </div>
  );
}
